var map = {
	"./1.jpg": "6704",
	"./2.jpg": "2e72",
	"./3.jpg": "7f27",
	"./4.jpg": "0215",
	"./5.jpg": "7d74",
	"./6.jpg": "38e3",
	"./7.jpg": "23e3",
	"./8.jpg": "000c",
	"./9.jpg": "9d84"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "09f1";